// Hooks/IAprofileHooks/useIAProfileData.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const useIAProfileData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://niaserver-05287f289508.herokuapp.com/iaProfile/getAll');
        console.log('API Response:', response); 
        console.log('API Response Data:', response.data); 

        // check if the data is correct   beofrkje
        if (Array.isArray(response.data) && response.data.length > 0) {
          const dataRows = response.data[0]; // Access the first array
          setData(dataRows); // Set the actual rows data
        }

        setLoading(false); 
      } catch (err) {
        console.error('Error fetching data:', err.response || err); 
        setError(err); 
        setLoading(false); 
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};

export default useIAProfileData;
